import React from "react";

const AddWebsite = () => {
  return <h1>Add Website</h1>;
};

export default AddWebsite;
